import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Privacy() {
  return (
    <PageLayout
      title="Privacy Policy"
      subtitle="How Paygent collects, uses, and protects your personal information."
      badge="LEGAL"
    >
      <div className="prose prose-lg max-w-4xl mx-auto text-gray-600">
        <p className="text-sm text-gray-400 mb-8">Last updated: April 23, 2026</p>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
          <p>When you use Paygent's services, we may collect the following categories of information:</p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li><strong>Account Information:</strong> Name, email address, phone number, business name, and billing address provided during registration.</li>
            <li><strong>Transaction Data:</strong> Payment amounts, timestamps, merchant category codes, and card network metadata necessary to process payments.</li>
            <li><strong>Device & Usage Data:</strong> IP address, browser type, operating system, referring URLs, and interaction patterns with our dashboard and APIs.</li>
            <li><strong>Communications:</strong> Records of support requests, emails, and chat interactions with our team or AI concierge.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Processing and settling payment transactions on your behalf.</li>
            <li>Fraud detection, risk scoring, and compliance with anti-money laundering (AML) regulations.</li>
            <li>Improving our products, services, and AI-powered features.</li>
            <li>Sending transactional notifications, security alerts, and (with consent) marketing communications.</li>
            <li>Fulfilling legal obligations and responding to lawful requests from authorities.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Data Sharing</h2>
          <p>We do not sell your personal data. We share information only with:</p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li><strong>Payment Networks:</strong> Visa, Mastercard, and other card networks as required to authorize and settle transactions.</li>
            <li><strong>Banking Partners:</strong> Acquiring banks and sponsor banks that facilitate fund movement.</li>
            <li><strong>Service Providers:</strong> Cloud infrastructure (Vercel, Supabase), email delivery (Resend), and analytics providers operating under strict data processing agreements.</li>
            <li><strong>Legal Authorities:</strong> When required by law, subpoena, or court order.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Data Security</h2>
          <p>Paygent maintains PCI DSS Level 1 compliance, the highest level of certification in the payments industry. All cardholder data is encrypted using AES-256 at rest and TLS 1.3 in transit. We employ tokenization to ensure raw card numbers never touch your servers.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Retention</h2>
          <p>We retain transaction records for a minimum of 7 years as required by financial regulations. Account data is retained for the duration of your active account plus 30 days after closure. You may request deletion of non-regulated data at any time.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Your Rights</h2>
          <p>Depending on your jurisdiction, you may have the right to access, correct, delete, or port your personal data. To exercise these rights, contact us at <a href="mailto:privacy@gopaygent.com" className="text-blue-600 hover:underline">privacy@gopaygent.com</a>.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact</h2>
          <p>For privacy-related inquiries:</p>
          <p className="mt-2"><strong>Wheelcall LLC</strong><br />Atlanta, GA<br /><a href="mailto:privacy@gopaygent.com" className="text-blue-600 hover:underline">privacy@gopaygent.com</a></p>
        </section>
      </div>
    </PageLayout>
  );
}
